import api from "./axios";

// Get IG session for a committee
export async function getIGSession(committeeId) {
  try {
    const res = await api.get(`/committees/${committeeId}/ig-session/`);
    return res.data || { is_active: false, location: "", day: null, start_time: null, end_time: null };
  } catch (error) {
    console.error("Error fetching IG session:", error);
    throw error;
  }
}

// Update/create IG session for a committee
export async function updateIGSession(committeeId, sessionData) {
  try {
    const res = await api.post(`/committees/${committeeId}/ig-session/`, sessionData);
    return res.data;
  } catch (error) {
    throw error;
  }
}